export const RTM_MESSAGE_TYPE = {
   TURN_OFF_COMMENT: -1,
   TURN_ON_COMMENT: 0,
   MESSAGE: 1,
   LIKE: 3,
   USER_LEFT: 101,
   USER_JOIN: 100,
   STATISTICS: 2,
   HOST_KICKED: 202,
   HOST_UNKICKED: 212,
   HOST_MUTED: 204,
   HOST_UNMUTED: 205,
   START_SHARE_SCREEN: 1412,
   STOP_SHARE_SCREEN: 1413,
   HOST_UN_LOCKED_ROOM: 1415,
   HOST_STARTED_STREAM: 1414,
   HOST_STREAM_ENDED: 201,

   HOST_PINNED_MESSAGE: 209,
   HOST_UNPIN_MESSAGE: 210,
   HOST_SORT_PRODUCT: 211,

   /**
    * Admin actions:
    */
   ADMIN_KICK: 402,
   ADMIN_BLOCKED: 403,
   ADMIN_MUTED: 404,
   ADMIN_UN_MUTED: 405,
   ADMIN_PAUSED: 406,
   ADMIN_UN_KICK: 407,
   ADMIN_DELETE_MESSAGE: 411,

   /**
    * Custom message client to client
    */
   CUSTOM_GROUPMODE_MUTEALL: 1400,
   CUSTOM_GROUPMODE_ONLYHOST: 1401,
   CUSTOM_GROUPMODE_ABLECHAT: 1402,
   CUSTOM_MODE_HOST_KICK_USER: 1403,
   CUSTOM_MODE_HOST_UN_KICK_USER: 1404,
   CUSTOM_MODE_HOST_MUTE_USER: 1405,
   CUSTOM_MODE_HOST_UNMUTE_USER: 1406
};

export const ADMIN_ACC = {
   GuestId: 0,
   DISPLAY_NAME: "+admin"
};

export const RTM_CONFIGS = {
   MAXIMUM_RECEIVED_LIKES: 20,
   DELAY_ANIMATION_LIKE: 200
}